import { initializeApp } from 'firebase/app';
import { getAuth, signInWithRedirect, getRedirectResult, signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// online
const firebaseConfig = {
  apiKey: "AIzaSyAMDSBRRMi6ug5T36CQPcgwiLDzL7t6IFE",
  authDomain: "arvessa-6c78b.firebaseapp.com",
  projectId: "arvessa-6c78b",
  storageBucket: "arvessa-6c78b.firebasestorage.app",
  messagingSenderId: "221703001858",
  appId: "1:221703001858:web:3c4a4112cae0a009e3d41b",
  measurementId: "G-KCRTR8K1H9"
};

// pre
// const firebaseConfig = {
//   apiKey: "AIzaSyCKEgCi6rdku_HYocf11jcBNGvaNNFBKwk",
//   authDomain: "papibangpre.firebaseapp.com",
//   projectId: "papibangpre",
//   storageBucket: "papibangpre.firebasestorage.app",
//   messagingSenderId: "473132553985",
//   appId: "1:473132553985:web:cc434187e2f337a9fead00",
//   measurementId: "G-VJ5VY5GVEB"
// };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {
  app,
  auth
};